<template>
    <div>
        <div class='panHeader'>
            <div class='panHeader0 panHeader1'>
                <el-radio-group @change="getData" size='medium' v-model.trim="query.dataType" > 
                    <el-radio-button label="1">订单数据大盘</el-radio-button>    
                    <el-radio-button label="2">转化率分析</el-radio-button>  
                    <el-radio-button label="3">预警风控面板</el-radio-button>  
                    <el-radio-button label="4">数据分析面板</el-radio-button>  
                    <!-- el-radio-button label="4">资源分析</el-radio-button>   
                    <el-radio-button label="4">产品分析</el-radio-button>   
                    <el-radio-button label="4">渠道分析</el-radio-button>   
                    <el-radio-button label="4">用户分析</el-radio-button> -->
                </el-radio-group> 
            </div>
            <div class='panHeader0 panHeader2'>
                <h2>数据可视化面板</h2> 
            </div>
            <div  class='panHeader0 panHeader3'> 
                <p>更新倒计时<br>60S</p> 
            </div>
        </div> 
        <i class='closex el-icon-close' @click="closeCharts" style='cursor:pointer'></i>
        <div class='panBody'>
            <el-row :gutter="0">  
                <el-col > 
                    <el-row :gutter="4" class="mgb20"> 
                        <el-col :span="3">
                            <el-card shadow="alwyas">
                                <div class="grid-content grid-con-1" @click="open2">
                                    <i class="el-icon-c-scale-to-original grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">￥{{form1.cashOver}}</div> 
                                        <div>累计进单数量</div>
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="3">
                            <el-card shadow="hover">
                                <div class="grid-content grid-con-2"  @click="open2">
                                    <i class="el-icon-guide grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">￥{{form1.cashTotal}}</div>
                                        <div>累计成功订单</div> 
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                        <el-col :span="3">
                            <el-card shadow="hover">
                                <div class="grid-content grid-con-3"  @click="open2">
                                    <i class="el-icon-finished grid-con-icon"></i>
                                    <div class="grid-cont-right">
                                        <div class="grid-num">{{form1.cashTotal}} %</div>
                                        <div>整体平均转化</div> 
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row> 
                    <div class="row">
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <div class="funfact-one__single-outer">
                                <div class="funfact-one__single" @click="open3"> 
                                
                                    <h3 class="funfact-one__title counter">{{orderNum.currOrder}}</h3><!-- /.funfact-one__title -->
                                    <p class="funfact-one__tag-line">上月成功订单</p><!-- /.funfact-one__tag-line -->
                                </div><!-- /.funfact-one__single -->
                            </div><!-- /.funfact-one__single-outer -->
                        </div><!-- /.col-lg-3 --> 
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <div class="funfact-one__single-outer">
                                <div class="funfact-one__single" @click="open3"> 
                                    <h3 class="funfact-one__title counter" style="color:rgb(100, 213, 114);">{{orderNum.currOrderY}}</h3><!-- /.funfact-one__title -->
                                    <p class="funfact-one__tag-line">本月成功订单</p><!-- /.funfact-one__tag-line -->
                                </div><!-- /.funfact-one__single -->
                            </div><!-- /.funfact-one__single-outer -->
                        </div><!-- /.col-lg-3 -->
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <div class="funfact-one__single-outer">
                                <div class="funfact-one__single" @click="open3"> 
                                    <h3 class="funfact-one__title counter" style="color:rgb(242, 94, 67)">{{orderNum.currCash}}</h3><!-- /.funfact-one__title -->
                                    <p class="funfact-one__tag-line">上周成功订单</p><!-- /.funfact-one__tag-line -->
                                </div><!-- /.funfact-one__single -->
                            </div><!-- /.funfact-one__single-outer -->
                        </div><!-- /.col-lg-3 -->
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <div class="funfact-one__single-outer">
                                <div class="funfact-one__single" @click="open3"> 
                                    <h3 class="funfact-one__title counter">{{orderNum.allOrder}}</h3><!-- /.funfact-one__title -->
                                    <p class="funfact-one__tag-line">本周成功订单</p><!-- /.funfact-one__tag-line -->
                                </div><!-- /.funfact-one__single -->
                            </div><!-- /.funfact-one__single-outer -->
                        </div><!-- /.col-lg-3 -->
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <div class="funfact-one__single-outer">
                                <div class="funfact-one__single" @click="open3"> 
                                    <h3 class="funfact-one__title counter" style="color:rgb(100, 213, 114);">{{orderNum.allOrderY}}</h3><!-- /.funfact-one__title -->
                                    <p class="funfact-one__tag-line" >昨日成功订单</p><!-- /.funfact-one__tag-line -->
                                </div><!-- /.funfact-one__single -->
                            </div><!-- /.funfact-one__single-outer -->
                        </div><!-- /.col-lg-3 -->
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <div class="funfact-one__single-outer">
                                <div class="funfact-one__single" @click="open3"> 
                                    <h3 class="funfact-one__title counter" style="color:rgb(242, 94, 67)">￥{{orderNum.allCash}}</h3><!-- /.funfact-one__title -->
                                    <p class="funfact-one__tag-line">今日成功</p><!-- /.funfact-one__tag-line -->
                                </div><!-- /.funfact-one__single -->
                            </div><!-- /.funfact-one__single-outer -->
                        </div><!-- /.col-lg-3 -->
                <!-- /.row -->
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <div class="funfact-one__single-outer">
                                <div class="funfact-one__single" @click="open3"> 
                                
                                    <h3 class="funfact-one__title counter">{{orderNum.currOrder}}</h3><!-- /.funfact-one__title -->
                                    <p class="funfact-one__tag-line">上月转化率</p><!-- /.funfact-one__tag-line -->
                                </div><!-- /.funfact-one__single -->
                            </div><!-- /.funfact-one__single-outer -->
                        </div><!-- /.col-lg-3 --> 
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <div class="funfact-one__single-outer">
                                <div class="funfact-one__single" @click="open3"> 
                                    <h3 class="funfact-one__title counter" style="color:rgb(100, 213, 114);">{{orderNum.currOrderY}}</h3><!-- /.funfact-one__title -->
                                    <p class="funfact-one__tag-line">本月转化率</p><!-- /.funfact-one__tag-line -->
                                </div><!-- /.funfact-one__single -->
                            </div><!-- /.funfact-one__single-outer -->
                        </div><!-- /.col-lg-3 -->
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <div class="funfact-one__single-outer">
                                <div class="funfact-one__single" @click="open3"> 
                                    <h3 class="funfact-one__title counter" style="color:rgb(242, 94, 67)">￥{{orderNum.currCash}}</h3><!-- /.funfact-one__title -->
                                    <p class="funfact-one__tag-line">上周转化率</p><!-- /.funfact-one__tag-line -->
                                </div><!-- /.funfact-one__single -->
                            </div><!-- /.funfact-one__single-outer -->
                        </div><!-- /.col-lg-3 -->
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <div class="funfact-one__single-outer">
                                <div class="funfact-one__single" @click="open3"> 
                                    <h3 class="funfact-one__title counter">{{orderNum.allOrder}}</h3><!-- /.funfact-one__title -->
                                    <p class="funfact-one__tag-line">本周转化率</p><!-- /.funfact-one__tag-line -->
                                </div><!-- /.funfact-one__single -->
                            </div><!-- /.funfact-one__single-outer -->
                        </div><!-- /.col-lg-3 -->
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <div class="funfact-one__single-outer">
                                <div class="funfact-one__single" @click="open3"> 
                                    <h3 class="funfact-one__title counter" style="color:rgb(100, 213, 114);">{{orderNum.allOrderY}}</h3><!-- /.funfact-one__title -->
                                    <p class="funfact-one__tag-line" >昨日转化率</p><!-- /.funfact-one__tag-line -->
                                </div><!-- /.funfact-one__single -->
                            </div><!-- /.funfact-one__single-outer -->
                        </div><!-- /.col-lg-3 -->
                        <div class="col-lg-3 col-md-6 col-sm-12">
                            <div class="funfact-one__single-outer">
                                <div class="funfact-one__single" @click="open3"> 
                                    <h3 class="funfact-one__title counter" style="color:rgb(242, 94, 67)">￥{{orderNum.allCash}}</h3><!-- /.funfact-one__title -->
                                    <p class="funfact-one__tag-line">今日转化率</p><!-- /.funfact-one__tag-line -->
                                </div><!-- /.funfact-one__single -->
                            </div><!-- /.funfact-one__single-outer -->
                        </div><!-- /.col-lg-3 -->
                    </div><!-- /.row -->
                    <!--<el-card shadow="hover" class="mgb20" style="height:252px;">
                        <div class="user-info">
                            <img :src="avatar" class="user-avator" alt />
                            <div class="user-info-cont">
                                <div class="user-info-name">{{name}}</div>
                                <div>{{role}}</div>
                            </div> 
                        </div>
                        <div class="user-info-list">
                            上次登录时间：
                            <span>2023-04-15</span>
                        </div>
                        <div class="user-info-list">
                            上次登录地点：
                            <span>杭州</span>
                        </div>
                    </el-card>
                    -->
                    <el-row :gutter="0">
                        <el-col :span="24">
                            <el-card shadow="hover">
                                <schart ref="line" class="schart" canvasId="line" :options="options2"></schart>
                            </el-card>
                        </el-col>
                        <el-col :span="24">
                            <el-card shadow="hover">
                                <schart ref="bar" class="schart" canvasId="bar" :options="options"></schart>
                            </el-card>
                        </el-col> 
                    </el-row>  
                    <el-card shadow="always" >
                        <div slot="header" class="clearfix">
                            <span>最近30天渠道销售占比</span>
                        </div> 
                        商城订单
                        <el-progress  :stroke-width="10" :percentage="orderMemberNum" color="#42b983"></el-progress>
                        下游订单
                        <el-progress :stroke-width="10" :percentage="orderDailiNum" color="#f1e05a"></el-progress>
                        抖音订单
                        <el-progress :stroke-width="10" :percentage="orderDYNum"></el-progress>
                        快手订单
                        <el-progress :stroke-width="10" :percentage="orderKSNum" color="#f56c6c"></el-progress>
                        <el-item v-if="query.mid==1" >API订单
                            <el-progress  :stroke-width="10" :percentage="orderApiNum" color="#333333"></el-progress>
                        </el-item>
                    </el-card>
                </el-col>
                
                    
            </el-row>
        </div>  
         
    </div>  
    
</template>

<script>
import Schart from 'vue-schart';
import bus from '../common/bus';
import {fetchData,getMessage} from '../../api/dashBoard';
import {getPayInfo} from '../../api/cashApply';  
export default {
    name: 'dashboard',
    data() {
        return { 
            accessNum : 0,
            messageNum : 0,
            orderMemberNum : 0,
            orderDYNum : 0,
            orderKSNum : 0,
            orderApiNum : 0,
            orderDailiNum : 0,
            orderNum:[],
            form1: {  
                payType:2,
            },  
            payImg:require('/public/base-img.png') ,
            query:{dataType:'1',stationId:'',shopCode:''},
            avatar:'',
            mesData:[], 
            mid:'',
            rid:'',
            stationId:'',
            addVisible:false,
            todoList: [
                {
                    title: '今天要引流了',
                    status: false
                },
                {
                    title: '今天要发朋友圈了',
                    status: false
                },
                {
                    title: '今天要拍视频了',
                    status: false
                },
                {
                    title: '今天要写文案',
                    status: false
                },
                {
                    title: '今天要推卡了',
                    status: true
                },
                {
                    title: '今天要收代理了',
                    status: true
                }
            ],
            data: [
                {
                    name: '2018/09/04',
                    value: 1083
                },
                {
                    name: '2018/09/05',
                    value: 941
                },
                {
                    name: '2018/09/06',
                    value: 1139
                },
                {
                    name: '2018/09/07',
                    value: 816
                },
                {
                    name: '2018/09/08',
                    value: 327
                },
                {
                    name: '2018/09/09',
                    value: 228
                },
                {
                    name: '2018/09/10',
                    value: 1065
                }
            ],
            options: {
                type: 'bar',
                title: {
                    text: '最近产品销售图'
                },
                xRorate: 25,
                labels: ['周一', '周二', '周三', '周四', '周五'],
                datasets: [
                    {
                        label: '联通',
                        data: [234, 278, 270, 190, 230]
                    },
                    {
                        label: '移动',
                        data: [164, 178, 190, 135, 160]
                    },
                    {
                        label: '电信',
                        data: [144, 198, 150, 235, 120]
                    }
                ]
            },
            options2: {
                type: 'line',
                title: {
                    text: '最近30天订单增长趋势图'
                },
                labels: ['6月', '7月', '8月', '9月', '10月'],
                datasets: [
                    {
                        label: '联通',
                        data: [234, 278, 270, 190, 230]
                    },
                    {
                        label: '移动',
                        data: [164, 178, 150, 135, 160]
                    },
                    {
                        label: '电信',
                        data: [74, 118, 200, 235, 90]
                    }
                ]
            }
        };
    },
    components: {
        Schart
    },
    mounted() {
        
        //this.cashApplySet();
        //this.getData();  
        //查询系统消息
        //this.getMessage();
    }, 
    computed: {
        role() {
            //return localStorage.getItem('ms_rid') == 1 ? '超级管理员' :localStorage.getItem('ms_rid') == 2 ? '站长' : '代理商';
        }
    },
    // created() {
    //     this.handleListener();
    //     this.changeDate();
    // },
    // activated() {
    //     this.handleListener();
    // },
    // deactivated() {
    //     window.removeEventListener('resize', this.renderChart);
    //     bus.$off('collapse', this.handleBus);
    // },
    methods: {
        numFilter(value) { 
            const realVal = parseFloat(value).toFixed(2); 
            return realVal; 
        },
        cashApplySet(){  
            getPayInfo(this.query).then(res => { 
                if(res.code=='200'){ 
                    this.form1 = res.data;  
                }else{  
                    this.$message.error("用户数据异常，请联系技术解决");
                }  
                  
            });  
        },
        closeCharts(){
            this.$router.push('/comOrder'); 
        },
        changeDate() {
            const now = new Date().getTime();
            this.data.forEach((item, index) => {
                const date = new Date(now - (6 - index) * 86400000);
                item.name = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
            });
        },
         
        //查询
        getData(){
            // 获取列表数据   
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.orderNum = res.data; 
                    this.orderMemberNum = this.numFilter(res.data.orderMemberNum*100/ res.data.orderNum);
                    this.orderDYNum = this.numFilter(res.data.orderDYNum*100/ res.data.orderNum);
                    this.orderKSNum = this.numFilter(res.data.orderKSNum*100/ res.data.orderNum);
                    this.orderApiNum = this.numFilter(res.data.orderApiNum*100/ res.data.orderNum);
                    this.orderDailiNum = this.numFilter(res.data.orderDailiNum*100/ res.data.orderNum);
                } 
            });
        },
        open1(){
            this.$router.push('/userAccess');
        },
        open2(){
            this.$router.push('/message');
        },
        open3(){
            this.$router.push('/orderIndex');
        },
        getMessage(){
            // 获取消息数据    
            getMessage(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.mesData = res.data;  
                    if(this.mesData && this.mesData.length>0){
                        for(var i=0;i<this.mesData.length;i++){ 
                             this.open(this.mesData[i],i); 
                        }
                    }
                } 
            });
        },
        //展开消息
        open(row,i){  
            this.message({
                title: row.title,
                dangerouslyUseHTMLString: true,
                message: row.content,
                duration:30000,
                offset: 50*i+100,   
            });
        }, 
        // handleListener() {
        //     bus.$on('collapse', this.handleBus);
        //     // 调用renderChart方法对图表进行重新渲染
        //     window.addEventListener('resize', this.renderChart);
        // },
        // handleBus(msg) {
        //     setTimeout(() => {
        //         this.renderChart();
        //     }, 200);
        // },
        // renderChart() {
        //     this.$refs.bar.renderChart();
        //     this.$refs.line.renderChart();
        // }
    }
};
</script>


<style>
.funfact-one {
  padding-top:60px;
}
.funfact-one .block-title {
  margin-bottom: 20px;
}
.funfact-one__single {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); 
  position: relative; 
  background-color: white;
  width: 100%;
  height: 150px;
  margin-left: auto;
  margin-right: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  overflow: hidden;
}
.funfact-one__single-outer {   
  display: inline-block;
}
.funfact-one__single:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%; 
  height: 100%;
  background: #98caff; 
 
  -webkit-transform: scale(0, 0);
          transform: scale(0, 0);
  -webkit-transition: -webkit-transform .4s ease;
  transition: -webkit-transform .4s ease;
  transition: transform .4s ease;
  transition: transform .4s ease, -webkit-transform .4s ease;
}
.funfact-one__single:hover:before {
  -webkit-transform: scale(1, 1);
          transform: scale(1, 1);
}
.funfact-one__single:hover .funfact-one__title, .funfact-one__single:hover .funfact-one__tag-line {
  color: #fff;
}
.funfact-one__title {
  margin: 0;
  color: #111;
  font-size: 34px;
  letter-spacing: -0.04em;
  line-height: 1em;
  position: relative;
  -webkit-transition: all .4s ease;
  transition: all .4s ease;
}
.funfact-one__tag-line {
  color: #8B8C9C;
  font-size: 15px;
  letter-spacing: .2em;
  margin: 0;
  text-transform: uppercase;
  line-height: 1em;
  margin-top: 20px;
  position: relative;
  -webkit-transition: all .4s ease;
  transition: all .4s ease;
}

[class*=funfact-one__dot-] {
  position: absolute;
  width: 6px;
  height: 6px; 
  background-color: #ef7c19;
  -webkit-animation-fill-mode: both;
          animation-fill-mode: both;
  -webkit-animation-name: dotsAnim;
          animation-name: dotsAnim;
  -webkit-animation-timing-function: cubic-bezier(0.39, 0.58, 0.57, 1);
          animation-timing-function: cubic-bezier(0.39, 0.58, 0.57, 1);
  -webkit-animation-duration: 5s;
          animation-duration: 5s;
  -webkit-animation-iteration-count: infinite;
          animation-iteration-count: infinite;
}

.funfact-one__dot-1 {
  top: 45px;
  left: 60px;
}

.funfact-one__dot-2 {
  left: 45px;
  bottom: 60px;
}

.funfact-one__dot-3 {
  right: 45px;
  top: 120px;
}
.el-progress{
    margin-bottom:15px;
}
.col-lg-3{
     display:inline;
     width:33%; 
}
.el-col-8{
    width:50%; 
}
@media screen and (max-width:999px){
     
    .el-row {
        margin-bottom: 10px;
    }
    .el-card__body, .el-main{
        padding:0; 
    }
    .grid-con-icon {
        display:inline-block;
        font-size: 30px;
        width: 50px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        color: #fff;
    }
    .grid-content {
    display: flex;
    align-items: left;
    height: 50px;
    } 
    .grid-num {
    font-size: 18px;
    font-weight: bold;
    margin-top:10px;
    }
    .grid-cont-right {
    flex: 1;
    text-align: center;
    font-size: 12px;
    color: #999;
    }
    .user-info {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 2px solid #ccc;
        margin-bottom: 20px;
    }

    .user-avator {
        width: 60px;
        height: 60px; 
    }

    .user-info-cont {
        padding-left: 50px;
        flex: 1;
        font-size: 14px;
        color: #999;
    }

    .user-info-cont div:first-child {
        font-size: 25px;
        color: #222;
    }
    .funfact-one__single-outer{
        width:33.3%;
        margin-bottom:10px;
    }
    .funfact-one__single{
        height:100px;
    }
    .funfact-one__title{
        font-size:20px;
    }
    .funfact-one__tag-line{
        font-size:12px;
    }
}
@media screen and (min-width:1000px){
     .funfact-one__single-outer{
        width:16.6%;
        margin-bottom:20px;
    }
    .el-row {
        margin-bottom: 30px; 
    }
    .grid-con-icon {
    display:inline-block;
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #fff;
    }
    .grid-content {
    display: flex;
    align-items: center;
    height: 100px;
    } 
    .grid-num {
    font-size: 30px;
    font-weight: bold;
    }
    .grid-cont-right {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #999;
    } 
    .user-info {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 2px solid #ccc;
        margin-bottom: 20px;
    } 
    .user-avator {
        width: 120px;
        height: 120px; 
    }
     
    .user-name{ 
        font-size:15px; 
    }
    .user-info-cont {
        padding-left: 50px;
        flex: 1;
        font-size: 14px;
        color: #999;
    }

    .user-info-cont div:first-child {
        font-size: 30px;
        color: #222;
    }   
}



 
.grid-con-1 .grid-con-icon {
    background: rgb(45, 140, 240);
}

.grid-con-1 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-2 .grid-con-icon {
    background: rgb(100, 213, 114);
}

.grid-con-2 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-3 .grid-con-icon {
    background: #20a0ff
}

.grid-con-3 .grid-num {
    color: #20a0ff
}
.el-col-3{
    width:33.2%
}



.user-info-list {
    font-size: 14px;
    color: #999;
    line-height: 25px;
}

.user-info-list span {
    margin-left: 70px;
}

.mgb20 {
    margin-bottom: 10px;
}

.todo-item {
    font-size: 14px;
}

.todo-item-del {
    text-decoration: line-through;
    color: #999;
}

.schart {
    width: 100%;
    height: 300px;
}

.panHeader{
    width:100%;
    height: 50px; 
    padding:10px 0.5%;
    border-bottom:2px solid #ddd;
    margin:15px 0;
}
.panBody{
     
    height: 90vh; 
    overflow-y:scroll;
    overflow-x:hidden;
}
.panHeader1,.panHeader3{
    float:left; 
    width:40%; 
}
.panHeader2{ 
    float:left; 
    width:20%;
    text-align: center; 
}
.panHeader3{ 
    text-align: center; 
}
.closex{
    float:right;
    margin-top:-65px;
    font-size: 25px;
    margin-right:30px;
}
</style>
